/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseSvgInfoAdminDto } from '../../models/response-svg-info-admin-dto';

export interface GetPaginatedSvgInfos$Params {

/**
 * search query
 */
  query?: string;
  limit?: number;
  offset?: number;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}

export function getPaginatedSvgInfos(http: HttpClient, rootUrl: string, params?: GetPaginatedSvgInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseSvgInfoAdminDto>> {
  const rb = new RequestBuilder(rootUrl, getPaginatedSvgInfos.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseSvgInfoAdminDto>;
    })
  );
}

getPaginatedSvgInfos.PATH = '/svg-info-admin/search';
